import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Skeleton, Box } from '@mui/material';

export interface TenantListSkeletonProps {
    rows?: number;
}

export function TenantListSkeleton({ rows = 5 }: TenantListSkeletonProps) {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Subdomain</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Created</TableCell>
                        <TableCell>Last Activity</TableCell>
                        <TableCell>Region</TableCell>
                        <TableCell>Users</TableCell>
                        <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({ length: rows }).map((_, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Box>
                                    <Skeleton variant="text" width="60%" height={20} />
                                    <Skeleton variant="text" width="40%" height={16} />
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="80%" height={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="rounded" width={80} height={24} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="70%" height={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="70%" height={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="60%" height={20} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" width="30%" height={20} />
                            </TableCell>
                            <TableCell align="right">
                                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                                    <Skeleton variant="circular" width={32} height={32} />
                                    <Skeleton variant="circular" width={32} height={32} />
                                    <Skeleton variant="circular" width={32} height={32} />
                                </Box>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
